import Loader from "./Loader";
export { default as SmallLoader } from "./SmallLoader";
export { default as LoadingBlock } from "./LoadingBlock";
export { default as Loading } from "./Loading";
export { default as EntryLoader } from "./EntryLoader";

export default Loader;
export { Loader };
